import { MenuCategory, DashboardCard } from '@/types/menu';

export const menuCategories: MenuCategory[] = [
  {
    id: 'upload-management',
    title: 'アップロード管理',
    icon: '📤',
    items: [
      {
        id: 'upload-list',
        label: 'アップロード一覧',
        path: '/upload-management/list',
      },
      {
        id: 'upload-new',
        label: '新規アップロード',
        path: '/upload-management/new',
      },
      {
        id: 'upload-history',
        label: 'アップロード履歴',
        path: '/upload-management/history',
      },
      {
        id: 'upload-settings',
        label: '設定',
        path: '/upload-management/settings',
      },
    ],
  },
  {
    id: 'book-download',
    title: '書籍ダウンロード',
    icon: '📚',
    items: [
      {
        id: 'book-search',
        label: '書籍検索',
        path: '/book-download/search',
      },
      {
        id: 'book-list',
        label: 'ダウンロード一覧',
        path: '/book-download/list',
      },
      {
        id: 'book-history',
        label: 'ダウンロード履歴',
        path: '/book-download/history',
      },
    ],
  },
  {
    id: 'member-management',
    title: '会員管理',
    icon: '👥',
    items: [
      {
        id: 'member-list',
        label: '会員一覧',
        path: '/member-management/list',
      },
      {
        id: 'member-search',
        label: '会員検索',
        path: '/member-management/search',
      },
      {
        id: 'member-registration',
        label: '会員登録',
        path: '/member-management/registration',
      },
      {
        id: 'member-settings',
        label: '設定',
        path: '/member-management/settings',
      },
    ],
  },
  {
    id: 'mbs-conversion',
    title: 'MBS変換',
    icon: '🔄',
    items: [
      {
        id: 'mbs-convert',
        label: '変換実行',
        path: '/mbs-conversion/convert',
      },
      {
        id: 'mbs-list',
        label: '変換一覧',
        path: '/mbs-conversion/list',
      },
      {
        id: 'mbs-history',
        label: '変換履歴',
        path: '/mbs-conversion/history',
      },
      {
        id: 'mbs-settings',
        label: '設定',
        path: '/mbs-conversion/settings',
      },
    ],
  },
  {
    id: 'email-magazine',
    title: 'メールマガ用データDL',
    icon: '📧',
    items: [
      {
        id: 'email-download',
        label: 'データダウンロード',
        path: '/email-magazine/download',
      },
      {
        id: 'email-list',
        label: 'データ一覧',
        path: '/email-magazine/list',
      },
      {
        id: 'email-history',
        label: 'ダウンロード履歴',
        path: '/email-magazine/history',
      },
      {
        id: 'email-settings',
        label: '設定',
        path: '/email-magazine/settings',
      },
    ],
  },
  {
    id: 'donation-report',
    title: '献本レポート',
    icon: '📊',
    items: [
      {
        id: 'donation-list',
        label: 'レポート一覧',
        path: '/donation-report/list',
      },
      {
        id: 'donation-create',
        label: 'レポート作成',
        path: '/donation-report/create',
      },
      {
        id: 'donation-history',
        label: 'レポート履歴',
        path: '/donation-report/history',
      },
      {
        id: 'donation-settings',
        label: '設定',
        path: '/donation-report/settings',
      },
    ],
  },
  {
    id: 'settings',
    title: '設定管理',
    icon: '⚙️',
    items: [
      {
        id: 'settings-magazine-catch',
        label: 'マガジンキャッチ管理',
        path: '/admin/settings/magazine-catch',
      },
    ],
  },
];

export const dashboardCards: DashboardCard[] = [
  {
    id: 'upload-management',
    title: 'アップロード管理',
    description: '書籍情報や商品情報のアップロードを管理します',
    icon: '📤',
    path: '/upload-management',
    isAvailable: true,
    permissionRequired: 'uploadManagement',
  },
  {
    id: 'book-download',
    title: '書籍ダウンロード',
    description: '書籍データのダウンロードを行います',
    icon: '📚',
    path: '/book-download',
    isAvailable: true,
    permissionRequired: 'bookDownload',
  },
  {
    id: 'member-management',
    title: '会員管理',
    description: '会員情報の管理を行います',
    icon: '👥',
    path: '/member-management',
    isAvailable: true,
    permissionRequired: 'memberManagement',
  },
  {
    id: 'mbs-conversion',
    title: 'MBS変換',
    description: 'MBS形式への変換処理を行います',
    icon: '🔄',
    path: '/mbs-conversion',
    isAvailable: true,
    permissionRequired: 'mbsConversion',
  },
  {
    id: 'email-magazine',
    title: 'メールマガ用データDL',
    description: 'メールマガジン用のデータをダウンロードします',
    icon: '📧',
    path: '/email-magazine',
    isAvailable: true,
    permissionRequired: 'emailMagazine',
  },
  {
    id: 'donation-report',
    title: '献本レポート',
    description: '献本に関するレポートを作成・管理します',
    icon: '📊',
    path: '/donation-report',
    isAvailable: true,
    permissionRequired: 'donationReport',
  },
];
